export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-pet-parent-b8548badacb75eb0fb02bf109bb201ff.png";